import React from 'react';
import { defaultTemplate } from 'core/hoc';

function ErrorViewTemplate({ message, onClose, label, t }) {
	if (!label) label = 'CLOSE';
	return (
		<div>
			<div className="spc--bottom--med">{t(message)}</div>
			<button className="btn btn--med btn--secondary" onClick={onClose}>
				{t(label)}
			</button>
		</div>
	);
}

export default defaultTemplate(ErrorViewTemplate);
